/* eslint-disable import/prefer-default-export */
import * as types from '../../../constants/types/shared/requisition/RequisitionTypes';
import * as load from '../../../constants/types/shared/LoadingTypes';

export const paidRequisitionReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case load.LOADING_STARTS:
      return {
        ...state,
        isLoading: true,
      };

    case load.LOADING_STOPS:
      return {
        ...state,
        isLoading: false,
      };

    case types.GET_PAID_REQUISITION:
      return {
        ...state,
        paidRequisitions: payload.paidRequisitions,
        pages: payload.pages,
        isLoading: false,
      };

    default:
      return state;
  }
};
